// extracted by mini-css-extract-plugin
export default {"item":"header-nav-item_item__jdNeP"};